import { type AddEventCallback } from "../types.js";
import { findEventProvider } from "../utils/providers.js";
import { getBody } from "../utils/body.js";

export function patchFetch(callback: AddEventCallback): () => void {
  if (typeof window.fetch !== 'function') return () => {};
  const original = window.fetch;
  window.fetch = function (input: RequestInfo | URL, init?: RequestInit) {
    const provider = findEventProvider(input.toString());
    if (provider) {
      try {
        callback({
          endpoint: input.toString(),
          // @ts-expect-error method may not be typed strictly
          method: init?.method?.toUpperCase() || "GET",
          transport: "fetch",
          payload: init?.body && getBody(init?.body as string | FormData),
          provider,
        });
      } catch {
        // never abort client traffic
      }
    }

    // @ts-expect-error arguments forwarding
    return original.apply(this, arguments);
  };
  return () => { window.fetch = original; };
}
